export default __webpack_public_path__ + "static/media/artichoke.b7720c33.jpg";